import { OpsgenieTeamAri } from '@atlassian/ari/opsgenie';
import type { Team, DevOpsJiraProjectTypeEnum } from '../common/types.tsx';

export const getTeamById = (teams: Team[], id: string, defaultValue: Team): Team => {
	const found =
		id === null || id === '' ? defaultValue : teams && teams.filter((team) => team.id === id)[0];
	return found || defaultValue;
};

export const getTeamIdFromAri = (opsgenieTeamAri: string) => {
	try {
		return OpsgenieTeamAri.parse(opsgenieTeamAri).opsgenieTeamId;
	} catch (err) {
		return opsgenieTeamAri;
	}
};

export const mapToJiraProjectType = (jiraProjectType: string): DevOpsJiraProjectTypeEnum => {
	switch (jiraProjectType) {
		case 'JIRA_SOFTWARE':
			return 'JIRA_SOFTWARE';
		case 'JIRA_CORE':
			return 'JIRA_CORE';
		case 'JIRA_SERVICEDESK':
			return 'JIRA_SERVICEDESK';
		default:
			throw new Error(`Unrecognised project type: ${jiraProjectType}`);
	}
};
